export default {
    GET_EXTERNAL_STOCK: '[STOCK] GET_EXTERNAL_STOCK',
    GET_EXTERNAL_STOCK_RESULT: '[STOCK] GET_EXTERNAL_STOCK_RESULT',
    SHOW_EXTERNAL_STOCK: '[STOCK] SHOW_EXTERNAL_STOCK',
    CANCEL_EXTERNAL_STOCK: '[STOCK] CANCEL_EXTERNAL_STOCK'
}


// WEBPACK FOOTER //
// ./src/view/constant/StockConstant.js